/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Payment_AnswerInputs */

const en_landing_faq_payment_answer = /** @type {(inputs: Landing_Faq_Payment_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe, PayPal, Creem, Alipay, and WeChat Pay out of the box. The PaymentManager abstraction makes it straightforward to add more providers by implementing a single interface.`)
};

const zh_landing_faq_payment_answer = /** @type {(inputs: Landing_Faq_Payment_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开箱即用支持 Stripe、PayPal、Creem、支付宝和微信支付。通过 PaymentManager 抽象层，只需实现一个接口就能接入新的支付渠道。`)
};

/**
* | output |
* | --- |
* | "Stripe, PayPal, Creem, Alipay, and WeChat Pay out of the box. The PaymentManager abstraction makes it straightforward to add more providers by implementing a..." |
*
* @param {Landing_Faq_Payment_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_faq_payment_answer = /** @type {((inputs?: Landing_Faq_Payment_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Payment_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_faq_payment_answer(inputs)
	return zh_landing_faq_payment_answer(inputs)
});
export { landing_faq_payment_answer as "landing.faq.payment.answer" }